const baseURL = 'http://miturnoadri.grupoinformaticofc.com';

export default baseURL;
